/* Trenzo Advance/COD Injector
 * -----------------------------
 * Koi Liquid file edit nahi karta — pure JS se cart drawer + cart page ke
 * subtotal ke neeche 30% Advance / 70% COD breakdown inject karta hai.
 * Har cart update (add/change/quantity) ke baad khud refresh ho jata hai.
 */
(function () {
  'use strict';
  if (window.__trenzoAdvanceCodLoaded) return;
  window.__trenzoAdvanceCodLoaded = true;

  // Flat shipping charge (in cents) that gets added at checkout.
  // Rs 300 => 300 * 100 = 30000. Change this single number if the rate ever changes.
  var SHIPPING_CENTS = 30000;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    try {
      var fmt = window.MinimogSettings && window.MinimogSettings.money_format;
      if (fmt) return fmt.replace('{{amount}}', amount);
    } catch (e) {}
    return 'Rs.' + amount;
  }

  function buildBox(subtotalCents) {
    // Grand total = cart subtotal + flat shipping (shipping isn't in cart.total_price,
    // Shopify only adds it at checkout, so we add it here manually).
    var grandTotalCents = subtotalCents + SHIPPING_CENTS;
    var advance = Math.round(grandTotalCents * 30 / 100);
    var cod = grandTotalCents - advance;

    var box = document.createElement('div');
    box.className = 'trenzo-advance-cod-box';
    box.setAttribute(
      'style',
      'margin:14px 0;padding:12px 14px;border:1px solid #e5c98a;border-radius:8px;background:#fff8e6;box-sizing:border-box;width:100%;max-width:100%;overflow:visible;'
    );
    box.innerHTML =
      '<p style="display:flex;justify-content:space-between;align-items:center;margin:0 0 6px 0;font-size:13px;">' +
        '<span>Shipping</span>' +
        '<strong style="font-size:14px;">' + money(SHIPPING_CENTS) + '</strong>' +
      '</p>' +
      '<p style="display:flex;justify-content:space-between;align-items:center;margin:0 0 8px 0;padding-bottom:8px;border-bottom:1px dashed #e5c98a;font-size:13px;">' +
        '<span><strong>Total</strong></span>' +
        '<strong style="font-size:14px;">' + money(grandTotalCents) + '</strong>' +
      '</p>' +
      '<p style="display:flex;justify-content:space-between;align-items:center;margin:0 0 6px 0;font-size:13px;">' +
        '<span>30% (Advanced)</span>' +
        '<strong style="font-size:14px;">' + money(advance) + '</strong>' +
      '</p>' +
      '<p style="display:flex;justify-content:space-between;align-items:center;margin:0 0 6px 0;font-size:13px;">' +
        '<span>70% (VIA COD)</span>' +
        '<strong style="font-size:14px;color:#b15c00;">' + money(cod) + '</strong>' +
      '</p>' +
      '<p style="margin:0 0 4px 0;font-size:11px;line-height:1.5;color:#7a6126;word-wrap:break-word;overflow-wrap:break-word;white-space:normal;">After placing your order, please send the advance payment screenshot via WhatsApp to confirm.</p>' +
      '<p style="margin:0;font-size:11px;line-height:1.5;color:#7a6126;word-wrap:break-word;overflow-wrap:break-word;white-space:normal;">Note: The 30%/70% split above already includes the Rs 300 shipping charge, so it will match the final total shown at checkout.</p>';
    return box;
  }

  function injectInto(subtotalEl, subtotalCents) {
    if (!subtotalEl || !subtotalEl.parentNode) return;
    var existing = subtotalEl.parentNode.querySelector(':scope > .trenzo-advance-cod-box')
      || (subtotalEl.nextElementSibling && subtotalEl.nextElementSibling.classList.contains('trenzo-advance-cod-box') ? subtotalEl.nextElementSibling : null);
    if (existing) existing.remove();
    if (subtotalCents > 0) {
      subtotalEl.insertAdjacentElement('afterend', buildBox(subtotalCents));
    }
  }

  function refresh() {
    fetch(root() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
          injectInto(el, cart.total_price);
        });
      })
      .catch(function () {});
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // Re-run whenever theme's own pub/sub says cart changed
  try {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function () {
        setTimeout(refresh, 200);
      });
    }
  } catch (e) {}

  // Extra safety net: also hook fetch directly for add/change/update
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartMutation =
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1;

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartMutation && response.ok) {
        setTimeout(refresh, 250);
      }
      return response;
    });
  };
})();